import React, { FC, useState, useEffect, useMemo } from "react";
import { Button, Collapse, Popconfirm, Space } from "antd";

import {
  PlusCircleOutlined,
  DeleteOutlined,
  SettingOutlined,
  OrderedListOutlined,
} from "@ant-design/icons";
import {
  IMenuSettingChildren,
  IMenuSettingModel,
} from "states/menu-setting/menu-setting.models";
import { MenuSettingChildrenModal } from "./menu-modal-chilren";
import { t, CoreResource } from "shared/plugins/localization";
import {
  Cancel,
  MenuText,
  OkText,
  QuestionRemove,
  Sort,
} from "shared/constants/define-localization";
import { Sortable, SortItemModel } from "shared/components/sortable/sortable";
import { nanoid } from "@reduxjs/toolkit";

interface IMenuSettingItemProps {
  menuItems: IMenuSettingChildren[];
  onRemove: (id: number) => void;
  onAdd: (model: IMenuSettingModel) => void;
  onUpdate: (id: number, model: IMenuSettingModel) => void;
  onChange?: () => void;
}
const { Panel } = Collapse;
export const MenuSettingItemList: FC<IMenuSettingItemProps> = (props) => {
  const { menuItems, onRemove, onAdd, onUpdate, onChange } = props;
  const menuItemsMemo = useMemo(()=>{
    menuItems?.forEach((item,index) => {
      item.key = nanoid();
    });
    return menuItems;
  },[menuItems])
  const [model, setModel] = useState<IMenuSettingModel>(
    {} as IMenuSettingModel
  );
  const [isUpdateSort, setIsUpdateSort] = useState(false);
  const [isModal, setModal] = useState(false);
  const [isUpdate, setUpdate] = useState(false);
  const [indexChildren, setIndexChildren] = useState<number>(0);
  const handleToggleModal = () => {
    setModel({} as IMenuSettingModel);
    setModal(!isModal);
  };
  const genExtra = (id: number) => (
    <Space>
      <Button
        type="primary"
        onClick={(event) => {
          // If you don't want click extra trigger collapse, you can prevent this:
          event.stopPropagation();
          handleToggleModal();
          setIndexChildren(id);
          setUpdate(false);
        }}
        icon={<PlusCircleOutlined />}
      ></Button>
      <Popconfirm
        placement="topLeft"
        title={"Bạn có muốn xóa không ?"}
        onCancel={(event: any) => {
          // If you don't want click extra trigger collapse, you can prevent this:
          event.stopPropagation();
        }}
        onConfirm={() => removeItemChildren(id)}
        okText={"Đồng ý"}
        cancelText={"Hủy"}
      >
        <Button
          type="primary"
          danger
          onClick={(event) => {
            // If you don't want click extra trigger collapse, you can prevent this:
            event.stopPropagation();
            setIndexChildren(id);
          }}
          icon={<DeleteOutlined />}
        ></Button>
      </Popconfirm>
      <Button
        onClick={(event) => {
          // If you don't want click extra trigger collapse, you can prevent this:
          event.stopPropagation();
          if(menuItemsMemo[id]?.data?.length > 0){
            setIsUpdateSort(true);
          }
        }}
        icon={<OrderedListOutlined />}
      ></Button>
      <Button
        onClick={(event) => {
          // If you don't want click extra trigger collapse, you can prevent this:
          event.stopPropagation();
          handleToggleModal();
          setIndexChildren(id);
          setUpdate(true);
          setModel({ ...menuItems[id] });
        }}
        icon={<SettingOutlined />}
      ></Button>
    </Space>
  );
  const onAddMenuChildren = (menuModel: IMenuSettingModel) => {
    let modelTemp = { ...menuItems[indexChildren] };
    menuModel.id = Date.now();
    modelTemp.data.push(menuModel);
    onChange && onChange();
  };
  const removeItemChildren = (i: number) => {
    menuItems.splice(i, 1);
    onChange && onChange();
  };
  const onUpdateItemChildren = (i: number, menuObj: IMenuSettingModel) => {
    menuItems[i] = menuObj;
    onChange && onChange();
  };
  
  return (
    <div className="menu-setting-item-list ">
      {menuItemsMemo?.map((menuItem, index) => (
        <div className="menu-setting-item-inner mb-4">
          <Collapse
            defaultActiveKey={menuItem.data.length > 0 ? [menuItem?.name] : []}
            expandIconPosition={`right`}
            bordered={menuItem.data.length > 0 ? true : false}
          >
            <Panel
              showArrow={menuItem.data.length > 0 ? true : false}
              header={menuItem?.name}
              key={menuItem?.name}
              extra={genExtra(index)}
            >
              <MenuSettingItemList
                menuItems={menuItem?.data}
                onAdd={onAddMenuChildren}
                onRemove={removeItemChildren}
                onUpdate={onUpdateItemChildren}
                onChange={onChange && onChange}
              />
              <Sortable
                model={
                  menuItem?.data.map((item) => ({
                    key: item?.key,
                    title: item.name,
                    sort: item.sort ?? 0,
                  }))  as SortItemModel[]
                }
                onCancel={async () => {
                  setIsUpdateSort(false);
                }}
                onOk={async (results) => {
                  menuItem?.data.forEach((m) => {
                    let old = results.some((r) => r.key === m.key);
                    if (old) {
                      m.sort =
                        results.find((r) => r.key === m.key)?.sort ??
                        0;
                    }
                  });
                  menuItem?.data.sort((a, b) => a.sort - b.sort);
                  onChange && onChange();
                   setIsUpdateSort(false);
                }}
                title={`${"Sắp xếp"} ${t(CoreResource, MenuText)}`}
                visible={isUpdateSort}
              ></Sortable>
            </Panel>
          </Collapse>
        </div>
      ))}
      <MenuSettingChildrenModal
        model={model}
        onModal={isModal}
        onSave={(model: IMenuSettingModel) => {
          isUpdate
            ? onUpdateItemChildren(indexChildren, model)
            : onAddMenuChildren(model);
        }}
        closeModal={handleToggleModal}
        onUpdate={isUpdate}
      />
    </div>
  );
};
